var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginHeader1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 83,
    viewBox: "0 0 109 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M0.685059 82.091H22.377C21.0775 61.1382 37.6715 56.0497 45.9684 57.8456L47.168 58.145C56.0647 60.0407 64.8615 54.4533 66.6608 45.3737C68.2603 37.6911 74.8578 32.3032 82.655 32.3032C92.0515 32.3032 100.348 26.2169 103.147 17.3369L108.445 0.474945H11.3811H0.685059V82.091Z",
    fill: "#098D98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginHeader1);
export default __webpack_public_path__ + "static/media/login-header1.152214bec98669d7b62fdd7568915956.svg";
export { ForwardRef as ReactComponent };